import { render, staticRenderFns } from "./DirectUploadPlayer.vue?vue&type=template&id=5362d327&scoped=true&"
import script from "./DirectUploadPlayer.vue?vue&type=script&lang=js&"
export * from "./DirectUploadPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5362d327",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5362d327')) {
      api.createRecord('5362d327', component.options)
    } else {
      api.reload('5362d327', component.options)
    }
    module.hot.accept("./DirectUploadPlayer.vue?vue&type=template&id=5362d327&scoped=true&", function () {
      api.rerender('5362d327', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/images/DirectUploadPlayer.vue"
export default component.exports